import { Collapse } from '@material-ui/core';

import { PaymentMethodConfiguration } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodConfiguration';
import { LoanPaymentHeaderComponent } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/LoanPaymentHeaderComponent';
import { withPaymentMethodCardWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodWrapper';
import { usePaymentMethodCardConfiguration } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/usePaymentMethodCardConfiguration';
import { ConsumerLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/entities/PaymentMethod/ConsumerLoanPaymentMethod';

interface ConsumerLoanPaymentMethodCardProps {
  paymentMethodEntity: ConsumerLoanPaymentMethod;
}

export const ConsumerLoanPaymentMethodCard = ({ paymentMethodEntity }: ConsumerLoanPaymentMethodCardProps) => {
  const { isConfigurationOpen, toggleConfiguration } = usePaymentMethodCardConfiguration(paymentMethodEntity);

  return (
    <>
      <LoanPaymentHeaderComponent
        paymentMethodEntity={paymentMethodEntity}
        isConfigurationOpen={isConfigurationOpen}
        toggleConfiguration={toggleConfiguration}
        hasLenders
      />
      <Collapse in={isConfigurationOpen}>
        <PaymentMethodConfiguration paymentMethodEntity={paymentMethodEntity} />
      </Collapse>
    </>
  );
};

export const ConsumerLoanPaymentMethodCardWithWrapper = withPaymentMethodCardWrapper(ConsumerLoanPaymentMethodCard);
